import { render, staticRenderFns } from "./D_RitualRed.vue?vue&type=template&id=0fdd5846&scoped=true&"
import script from "./D_RitualRed.vue?vue&type=script&lang=js&"
export * from "./D_RitualRed.vue?vue&type=script&lang=js&"
import style0 from "./D_RitualRed.vue?vue&type=style&index=0&id=0fdd5846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd5846",
  null
  
)

export default component.exports